import React from 'react';
import { Box, Container, SimpleGrid } from '@chakra-ui/react';
import SectionHeading from '../ui/SectionHeading';
import EnhancedPropertyCard from '../investments/EnhancedPropertyCard';

const PROPERTIES = [
  {
    id: '1',
    image: '/images/Properties/Dubai/thebay_business_bay.jpg',
    title: 'The Bay – Luxury Apartments',
    location: 'Business Bay - Dubai, UAE',
    roi: '12%',
    value: '$1.84M',
    funded: '100%',
    tag: 'Luxury',
    type: 'residential',
    details: {
      bedrooms: '2',
      sqft: '105',
      NoofUnits: '3',
      propertyType: 'Luxury Apartment',
      yearBuilt: '2021',
      minInvestment: '$2,000',
      investors: 156,
      rentalYield: '6.2%',
      occupancyRate: '98%',
      description:
        "Premium luxury apartments in Dubai's prestigious Business Bay district, offering stunning views and world-class amenities with excellent rental potential and investment growth.",
    },
  },
  {
    id: '2',
    image: '/images/Properties/Malaysia/rnfpcp2.jpeg',
    title: 'R&F Princess Cove Phase 1',
    location: 'Johor Bahru, Malaysia',
    roi: '17.5%',
    value: '$1.18M',
    funded: '100%',
    tag: 'Hot',
    type: 'residential',
    details: {
      bedrooms: '3',
      sqft: '102',
      NoofUnits: '4',
      propertyType: 'Residential Apartment',
      yearBuilt: '2019',
      minInvestment: '$1,000',
      investors: 481,
      rentalYield: '5.1%',
      occupancyRate: '95%',
      description:
        "R&F Princess Cove, Johor Bahru is a large, freehold luxury waterfront development popular with both Malaysian and Singaporean investors due to its proximity to the CIQ and Singapore, extensive amenities, and strong rental demand.",
    },
  },
  {
    id: '3',
    image: '/images/Properties/SM_Barsha.jpg',
    title: 'Smart Heights - Grade-A office suite',
    location: 'Barsha Heights (Tecom), Dubai',
    roi: '12.3%',
    value: '$552,000',
    funded: '100%',
    tag: 'Commercial',
    type: 'commercial',
    details: {
      sqft: '105',
      NoofUnits: '2',
      propertyType: 'Office Suites',
      yearBuilt: '2010',
      minInvestment: '$2,000',
      investors: 198,
      rentalYield: '9.2%',
      occupancyRate: '96%',
      description:
        "Smart Heights offers modern office spaces in a vibrant business district with excellent metro connectivity. High occupancy rates, flexible layouts, and a growing SME/startup ecosystem drive strong rental demand and good yields for commercial investment.",
    },
  },
];

const PropertiesSection = () => {
  return (
    <Box as="section" py={{ base: 8, md: 8 }} bg="#071326">
      <Container maxW="container.xl" px={{ base: 5, md: 8 }}>
        <SectionHeading
          title="Featured Investment Opportunities"
          subtitle=""
          align="left"
          mb={{ base: 5, md: 5 }}
        />

        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={5}>
          {PROPERTIES.map((property) => (
            <EnhancedPropertyCard
              key={property.id}
              id={property.id}
              image={property.image}
              title={property.title}
              location={property.location}
              roi={property.roi}
              value={property.value}
              funded={property.funded}
              tag={property.tag}
              type={property.type}
              details={property.details}
            />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default PropertiesSection;
